import { InjectionToken } from '@angular/core';
import { LocationsPort } from './locations.port';

export const LOCATIONS_PORT = new InjectionToken<LocationsPort>('LOCATIONS_PORT');